// a library to wrap and simplify api calls
import Api from './PhiApi'
import Constants from './Constants'

export default class PhiWorkflow {

    constructor(options) {
        this.phiRef = options

        this.get = function* (that, config, profile, customer) {
            let token = that.phiRef.getSession(that.phiRef)
            if (token) {
                let state = that.phiRef.getItem(that.phiRef, Constants.StoreKeys.STATE)
                if (!state) {
                    state = 'start'
                }
                console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>reading state', state)
                config = Object.assign({}, config, { userid: profile.user_id, customerid: customer.customer_id, userState: state })
                let response = yield Api.getNextTask(config)

                console.log('Response>>>>>>>>>>>>>>>>>>>', response)
                if (response.ok && response.data && response.data.task) {
                    let task = response.data.task
                    if (task.nextState) {
                        console.log('>>>>>>>>>>>>>>>>>>>>persisting state', task.nextState)
                        that.phiRef.persistItem(that.phiRef, Constants.StoreKeys.STATE, task.nextState)
                        that.phiRef.persistItem(that.phiRef, task.nextState, task)
                    }
                    return task
                }
                else {
                    return { error: response.problem }
                }
            }
            return null

        }

    }

}
